import { KnmInvalidFieldEnum } from '../enums/KnmInvalidFieldEnum';

export interface IInvalidField {
  name: string;
  required?: boolean;
}

export const knmInvalidFields: Record<KnmInvalidFieldEnum, IInvalidField> = {
  [KnmInvalidFieldEnum.KNO_ORGANIZATION_ERKNM]: {
    name: 'Наименование органа контроля',
    required: true,
  },
  [KnmInvalidFieldEnum.KIND_CONTROL]: {
    name: 'Вид контроля (надзора) и его номер',
    required: true,
  },
  [KnmInvalidFieldEnum.KIND_KNM]: {
    name: 'Вид КНМ',
  },
  [KnmInvalidFieldEnum.TYPE_ERKNM]: {
    name: 'Характер КНМ',
  },
  [KnmInvalidFieldEnum.REASONS_ERKNM_ERVK_UUID]: {
    name: 'Основание проведения КНМ',
  },
  [KnmInvalidFieldEnum.REASONS_ERKNM_ORDER]: {
    name: 'Поручение основания',
  },
  [KnmInvalidFieldEnum.REASONS_ERKNM_RISK_INDICATORS]: {
    name: 'Индикаторы риска основания',
  },
  [KnmInvalidFieldEnum.REASONS_ERKNM_RISK_INDICATOR]: {
    name: 'Индикаторы риска основания',
  },
  [KnmInvalidFieldEnum.PROSECUTOR_ORGANIZATION_ERKNM]: {
    name: 'Орган прокуратуры',
  },
  [KnmInvalidFieldEnum.OBJECTS_ERKNM_ERVK_ID]: {
    name: 'Сведения об объектах контроля',
  },
  [KnmInvalidFieldEnum.OBJECTS_ERKNM_OBJECT_TYPE]: {
    name: 'Тип объекта контроля',
  },
  [KnmInvalidFieldEnum.OBJECTS_ERKNM_OBJECT_KIND]: {
    name: 'Вид объекта контроля',
  },
  [KnmInvalidFieldEnum.OBJECTS_ERKNM_OBJECT_SUB_KIND]: {
    name: 'Подвид объекта контроля',
  },
  [KnmInvalidFieldEnum.OBJECTS_ERKNM_RISK_CATEGORY]: {
    name: 'Категория риска объекта контроля',
  },
  [KnmInvalidFieldEnum.OBJECTS_ERKNM_DANGER_CLASS]: {
    name: 'Класс опасности объекта контроля',
  },
  [KnmInvalidFieldEnum.ORGANIZATIONS_SUBJECT_TYPE]: {
    name: 'Тип контролируемого лица',
  },
  [KnmInvalidFieldEnum.ORGANIZATIONS_ERVK_ID]: {
    name: 'Связь контролируемого лица с объектом из ЕРВК',
  },
  [KnmInvalidFieldEnum.INSPECTORS_ERKNM_POSITION]: {
    name: 'Должности лиц, участвующих в КНМ, в разделе "Сведения о должностных лицах, участвующих в КНМ"',
  },
  [KnmInvalidFieldEnum.EXPERTS_TYPE]: {
    name:
      'Должности лиц, привлекаемых для проведения КНМ, в разделе "Сведения об экспертах, экспертных организациях, специалистах, независимых органах инспекции, саморегулируемых организациях и иных лицах, привлекаемых для проведения КНМ"',
  },
  [KnmInvalidFieldEnum.COLLABORATING_ORGANIZATIONS_ITEM_ORGANIZATION]: {
    name: 'Наименование органа контроля, с которым КНМ проводится совместно',
  },
  [KnmInvalidFieldEnum.EVENTS_ERKNM_TYPE]: {
    name: 'Перечень действий',
  },
  [KnmInvalidFieldEnum.REQUIREMENTS_NPA_ERKNM_NPA_ID]: {
    name: 'Обязательные требования, подлежащие проверке (НПА)',
  },
  [KnmInvalidFieldEnum.REQUIREMENTS_NPA_ERKNM_STRUCTURAL_UNIT_ID]: {
    name: 'Обязательные требования, подлежащие проверке (Структурные единицы)',
  },
  [KnmInvalidFieldEnum.DOC_TARGET_ERVK_CONTROL_KIND_DOC_TARGET]: {
    name: 'Разрешительные и иные документы',
  },
  [KnmInvalidFieldEnum.CHECKLISTS_ERKNM_CHECKLIST]: {
    name: 'Проверочные листы: Наименование проверочного листа',
  },
  [KnmInvalidFieldEnum.CHECKLISTS_ERKNM_ERVK_CHECKLIST]: {
    name: 'Проверочные листы: Номер и название из ЕРВК',
  },
};
